window.addEventListener("DOMContentLoaded", function() {
  // Function to initialize the script
  const initializeScript = () => {
    const sizeText = document.querySelector(".prod__option-label--dropdown .selected-value");
    console.log("Size text element:", sizeText);

    if (sizeText) {
      sizeText.textContent = "";
      console.log("Cleared size text content.");
    } else {
      console.log("Size text element not found.");
    }

    const sizeSelectContainer = document.querySelector('.prod__option--dropdown');
    const addToCartButton =  document.querySelector('.add_to_cart_button');
    const sizeSelectElement = sizeSelectContainer?.querySelector('select[name="options[Size]"]');
    const sizeWarningElement = document.createElement('div');
    
    console.log("Size Select Container:", sizeSelectContainer);
    console.log("Add to Cart Button Element:", addToCartButton);
    console.log("Size Select Element:", sizeSelectElement);

    if (sizeSelectContainer && addToCartButton && sizeSelectElement) {
      sizeSelectContainer.closest('.quick-view__info')?.classList.add('p-4', 'lg:p-8');
      console.log("Added classes 'p-4 lg:p-8' to parent element with class 'quick-view__info'.");

      addToCartButton.disabled = true;
      console.log("Add to Cart Button initially disabled:", addToCartButton.disabled);

      function checkSizeSelection() {
        const selectedSize = sizeSelectElement.value.trim();
        console.log("Currently selected size:", selectedSize);

        if (selectedSize) {
          addToCartButton.disabled = false;
          sizeWarningElement.style.display = 'none';
          console.log("Add to Cart Button enabled:", addToCartButton.disabled);
        } else {
          addToCartButton.disabled = true;
          sizeWarningElement.style.display = 'block';
          console.log("Add to Cart Button disabled:", addToCartButton.disabled);
        }
      }

      const sizeSelectObserver = new MutationObserver(function(mutations) {
        console.log("Mutation observed:", mutations);
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
            console.log("Relevant mutation detected, re-checking size selection.");
            checkSizeSelection();
          }
        });
      });

      sizeSelectObserver.observe(sizeSelectContainer, {
        childList: true,
        attributes: true,
        subtree: true
      });

      console.log("MutationObserver set up on size select container.");

      sizeWarningElement.textContent = 'Please select a size.';
      sizeWarningElement.style.color = 'red';
      sizeWarningElement.style.display = 'none';
      sizeSelectContainer.parentNode.insertBefore(sizeWarningElement, sizeSelectContainer.nextSibling);

      checkSizeSelection();
    } else {
      console.error("Error: Size select container, add to cart button, or size select element not found.");
    }
  };

  // Retry if elements are not found initially
  const interval = setInterval(() => {
    const sizeSelectContainer = document.querySelector('.prod__option--dropdown');
    const addToCartButton = document.querySelector('button[name="add"]');
    const sizeSelectElement = sizeSelectContainer?.querySelector('select[name="options[Size]"]');

    if (sizeSelectContainer && addToCartButton && sizeSelectElement) {
      initializeScript();
      clearInterval(interval); // Stop retrying once the elements are found
    }
  }, 1000); // Retry every second
});
